// Auth0 Config variables
export const auth0 = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
};

// API variables
export const API_URL = process.env.REACT_APP_API_URL as string;

// Variable to help with playlist items playing in perpetuity
export const INFINITY_END_DATE = '9999-01-01';

// Generic days of week constant
export const DAYS_OF_THE_WEEK = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

// Activity menu icons configuration
export interface IconItemInfo {
  name: string;
  extension: string;
}

export const ACTIVITY_MENU_ICONS = [
  { name: 'BELL', extension: 'svg' } as IconItemInfo,
  { name: 'MENU', extension: 'svg' } as IconItemInfo,
  { name: 'DRINK_MENU', extension: 'svg' } as IconItemInfo,
  { name: 'BILL', extension: 'svg' } as IconItemInfo,
  { name: 'CHECKIN', extension: 'svg' } as IconItemInfo,
  { name: 'REWARD', extension: 'svg' } as IconItemInfo,
  { name: 'SHARING', extension: 'svg' } as IconItemInfo,
  { name: 'CALENDAR', extension: 'svg' } as IconItemInfo,
  { name: 'CATERING', extension: 'svg' } as IconItemInfo,
  { name: 'FRANCHISING', extension: 'svg' } as IconItemInfo,
  { name: 'HIRE', extension: 'svg' } as IconItemInfo,
  { name: 'REVIEW', extension: 'svg' } as IconItemInfo,
  { name: 'AMI', extension: 'png' } as IconItemInfo,
  { name: 'CLT_GAMESHOW', extension: 'png' } as IconItemInfo,
  { name: 'PEPSI', extension: 'svg' } as IconItemInfo,
  { name: 'WIFI', extension: 'svg' } as IconItemInfo,
  { name: 'WAEV', extension: 'png' } as IconItemInfo,
  { name: 'BETCAROLINA', extension: 'png' } as IconItemInfo,
  { name: 'APOTHECA', extension: 'svg' } as IconItemInfo,
  { name: 'DRAFTKINGS', extension: 'svg' } as IconItemInfo,
  { name: 'LINK', extension: 'svg' } as IconItemInfo,
] as IconItemInfo[];

export const ICON_DIR =
  'https://waev-frontend-applications.s3.us-east-1.amazonaws.com/shared-assets/activity-menu-icons';
